import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-6 md:px-8 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          观众热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          综艺迷们都在聊什么
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.nickname}
                  className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{comment.nickname}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                {comment.content}
              </p>
              <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
                <span className="text-xs text-foreground-500">
                  在看《{comment.show}》
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-thumb-up-line text-primary-500"></i>
                  {comment.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}